module.exports = __webpack_public_path__ + "assets/img/robot.bc9c28ec.png";